exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#summaryGrid {\r\n    margin-top: 10px\r\n}\r\n\r\n.excel-download-button {\r\n    outline: solid;\r\n    outline-width: 1px;\r\n    outline-color: #242D4B;\r\n    border-radius: 2px;\r\n    margin-top: 2px;\r\n    align-self: flex-start;\r\n    margin-right: 16px;\r\n}\r\n\r\n.io-style {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .io-style {\r\n        flex-direction: column;\r\n    }\r\n    .excel-download-button {\r\n        margin-left: 16px;\r\n    }\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./App/containers/summary/summary.css
// module id = 1305
// module chunks = 0